import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CardDialog from '@/components/dialogs/CardDialog.vue'
import CheckList from '@/components/feedback/lists/CheckList.vue'
import * as _ from 'lodash-es'
import { useI18n } from 'vue-i18n'

interface Props {
  /** List of restrictions to display */
  restrictions: RestrictionResource[]
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'RestrictionDialog'
},
  __name: 'RestrictionDialog',
  props: {
    restrictions: {}
  },
  setup(__props: any) {





const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  const _component_VIcon = _resolveComponent("VIcon")!

  return (_openBlock(), _createBlock(CardDialog, {
    "hide-cancel": "",
    onAction: _cache[0] || (_cache[0] = ({ close }) => close())
  }, {
    "prepend-title": _withCtx(() => [
      _createVNode(_component_VIcon, {
        icon: "$information",
        color: "blue",
        size: "2rem"
      })
    ]),
    action: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('general.close_notification')), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(CheckList, {
        icon: "$close",
        color: "danger",
        items: _.map(__props.restrictions, 'name')
      }, null, 8, ["items"])
    ]),
    _: 1
  }))
}
}

})